import SlideOutMenuV2 from "@components/SlideOutMenuV2";
import { ProjectService, Note } from "../../types";
import { truncateString } from "@utils/helperFunctions";
import EditableDataTable from "@components/EditableDataTable";
import "./style.css";
import { Form } from "react-bootstrap";
import { faCheck, faX } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import SmallSpinner from "@components/SmallSpinner/SmallSpinner";
import { useUpdateProjectServiceMutation } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { formatDateAndTime } from "@utils/helpers";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";

interface Props {
  resource: ProjectService | null;
  onClose: () => void;
}
const ManageNotesSlideout = ({ resource, onClose }: Props) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const [newNote, setNewNote] = useState<{ content: string } | null>(null);
  const [notes, setNotes] = useState<Note[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [updateService] = useUpdateProjectServiceMutation();
  const { hasPrivilege } = usePrivilegeCheck();
  const managePrivilege = hasPrivilege("projects.notes", ["create", "manage"]);

  useEffect(() => {
    if (resource?.notes) setNotes(resource.notes);
  }, [resource]);

  const columns = [
    {
      id: "note",
      header: () => "Note",
      cell: (item) => item.content,
    },
    {
      id: "username",
      header: () => "By",
      cell: (item) => item.username,
    },
    {
      id: "created_at",
      header: () => "Time",
      cell: (item) =>
        item.created_at ? formatDateAndTime(new Date(item.created_at)) : "",
    },
  ];
  const confirmItem = async () => {
    if (!newNote?.content || !resource?.id) return;

    const data = {
      id: resource.id,
      type: "project-services",
      attributes: { notes: [...notes, { content: newNote.content }] },
    };

    const response = await updateService({
      slug: accountSlug,
      id: Number(resource.id),
      //@ts-ignore
      body: { data },
    });
    //@ts-ignore
    if (!response.error) {
      //@ts-ignore
      setNotes(response?.data?.data?.attributes?.notes || []);
    }
    setLoading(false);
    setNewNote(null);
  };

  return (
    <div className="notesSlideout">
      <SlideOutMenuV2
        title={`Notes ${
          resource?.name ? "- " + truncateString(resource.name, 30) : ""
        }`}
        isOpen={resource ? true : false}
        onClose={() => {
          setNewNote(null);
          onClose();
        }}
      >
        {loading ? (
          <SmallSpinner />
        ) : (
          <div className="manageNotesSlideout">
            {notes.length ? (
              <>
                <div className="notesSubheader">Existing Notes</div>
                <EditableDataTable
                  records={notes}
                  columns={columns}
                  config={{
                    striped: true,
                    bordered: true,
                    classForTable: newNote ? "addingNote" : "",
                  }}
                />
              </>
            ) : (
              <></>
            )}
            {newNote && (
              <div
                className={`newNote ${notes?.length % 2 ? "striped" : ""} ${
                  notes?.length ? "" : "borderTop"
                }`}
              >
                <Form.Control
                  as="textarea"
                  rows={3}
                  defaultValue={newNote?.content}
                  onChange={(e) =>
                    setNewNote({
                      content: e.target.value,
                    })
                  }
                  autoFocus={true}
                  placeholder="Enter note"
                />
                <FontAwesomeIcon
                  icon={faCheck}
                  onClick={() => {
                    setLoading(true);
                    confirmItem();
                  }}
                />
                <FontAwesomeIcon icon={faX} onClick={() => setNewNote(null)} />
              </div>
            )}

            {!newNote && managePrivilege && (
              <div
                className="addServiceBtn addNoteBtn"
                onClick={() => setNewNote({ content: "" })}
              >
                + Add Note
              </div>
            )}
          </div>
        )}
      </SlideOutMenuV2>
    </div>
  );
};

export default ManageNotesSlideout;
